export default __webpack_public_path__ + "static/media/bottles.2bb448b2.jpg";